import { AccountList, ImageSourceType } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { useAvailableAccountListHelper } from './availableAccountsList.helper';

export interface AvailableAccount {
	avatar?: ImageSourceType;
	number: string;
	name: string;
	iban: string;
}

interface AvailableAccountListProps {
	accounts: AvailableAccount[];
}

export const AvailableAccountList: React.FC<AvailableAccountListProps> = ({ accounts }) => {
	const { accountListItems } = useAvailableAccountListHelper(accounts);

	return (
		<AccountList
			items={accountListItems}
			borderRadius={'8px'}
			backgroundColor="#FFFFFF"
			divider={{ inside: false }}
		/>
	);
};
